module.exports = __webpack_public_path__ + "static/media/2.5b251f25.png";